module.exports = __webpack_public_path__ + "static/media/clc_booking_form_covid19.b674ac3b.png";